export type ImageDim = {width: number; height: number};

// Loads an image off-DOM to read its natural dimensions, reporting them (or an
// error) via callbacks so callers can size or fall back.
export const loadImage = (
  imageUrl: string,
  onLoad: (dim: ImageDim) => void,
  onError?: () => void
): void => {
  const img = new Image();
  img.src = imageUrl;
  img.onload = () => onLoad({width: img.width, height: img.height});
  img.onerror = err => {
    console.error('Failed to load image', imageUrl, err);
    onError?.();
  };
};
